
  var _styles = {
  "letter-index-fixed-container": {
    "position": "absolute",
    "top": 0,
    "paddingLeft": 0,
    "right": "0.12rem",
    "zIndex": 2
  },
  "letter-index-flex-center-container": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "flex-start"
  },
  "letter-index-touch-container": {
    "height": "100%",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "marginTop": "1.33333rem"
  },
  "letter-index-text": {
    "width": "0.32rem",
    "height": "0.32rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "textAlign": "center",
    "marginBottom": "0.04rem"
  },
  "letter-index-active": {
    "background": "#164294"
  },
  "letter-text-active": {
    "color": "rgb(255,255,255)"
  },
  "letter-index-big-letter-fixed-container": {
    "position": "absolute",
    "top": "50%",
    "left": "45%"
  },
  "letter-index-big-letter-flex-container": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "0.46667rem",
    "background": "#164294",
    "height": "0.93333rem",
    "width": "0.93333rem"
  },
  "letter-index-big-letter": {
    "fontSize": "0.53333rem",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFangSC-Medium"
  }
};



  module.exports = _styles;
  